import { Row, Col, Table, Spin, Button, message, Checkbox } from "antd";
import { useEffect, useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import api from "../../utils/api";
import { columns } from "./config";
import CreateAccountC from "../login-signup/CreateAccountC";
import "../pay-processing-defaults/PayProcessing.less";
import { register, updateUser } from "../../redux/user/action";
import { useDispatch } from "react-redux";
import { Switch } from "antd";
import { getAuthUser, getSelectedTenant, storeUser } from "../../utils/authToken";
import { getAssociatePeople } from "../../redux/associatePeople/action";

const Users = () => {
  const dispatch = useDispatch<any>();
  const [invalidEmail, setInvalidEmail] = useState("");
  const [users, setUsers] = useState<any>([]);
  const [companies, setCompanies] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState<any>({});
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const user = getAuthUser();
  const tenantId = getSelectedTenant();

  useEffect(() => {
    setLoading(true);
    api
      .get("user/users")
      .then((response: any) => {
        console.log(response);
        setLoading(false);
        setUsers(response);
      })
      .catch((err) => {
        setLoading(false);
      });
    api.get('defaults/company-info').then((response: any) => {
      console.log(response)
      setCompanies(response);
    })
  }, []);

  const handleAddUser = () => {
    setInvalidEmail("");
    setEdit({});
    setShowAddUserModal(true);
  };

  const toggleShowAddUserModal = (collapse: boolean) => {
    !showAddUserModal ? setShowAddUserModal(true) : setShowAddUserModal(false);
  };

  const onFinish = (values: any) => {
    console.log(values)
    if (Object.keys(edit).length > 0) {
      let contact;
      if (values.phone === "(___) ___-____") {
        contact = "";
      } else {
        contact = values.phone;
      }
      const currrentUserCompanyWithRespectToTenantId = edit.companyInfo.find((item: any) => item.tenant === tenantId);
      if (currrentUserCompanyWithRespectToTenantId._id !== values.companyInfo[0]) {
        const tempIndex = edit.companyInfo.findIndex((item: any) => item.tenant === tenantId);
        console.log(tempIndex)
        edit.companyInfo[tempIndex] = values.companyInfo[0]
      }

      const updatedBody = {
        ...edit,
        fullName: values.fullName,
        jobTitle: values.jobTitle,
        phone: contact,
        roles: values.roles,
        sendBidReview: false,
      };
      console.log(updatedBody)

      api.put(`user/${updatedBody._id}`, updatedBody).then((response: any) => {
        if (updatedBody._id === user._id) {
          const userData = {
            ...response,
            accessToken: user.accessToken,
          };

          dispatch(updateUser(userData));
          storeUser(userData);
        }
        const updatedResponse = {
          ...response,
          companyInfo: response.companyInfo.map((id: any) => {
            // Find the company object in the companies array that matches the _id
            const matchedCompany = companies.find((company: { _id: any; }) => company._id === id);
            // If a match is found, return the full company object; otherwise, keep the ID (or handle differently)
            return matchedCompany || id;
          }),
        };
        setUsers(
          users.map((item: any) => {
            if (item._id === updatedBody._id) {
              return updatedResponse;
            }
            return item;
          }),
        );
        message.success("User successfully updated");
        dispatch(getAssociatePeople());
      }
      );
    } else {
      dispatch(register(values))
        .then((resp: any) => {
          setUsers([...users, resp]);
          message.success(`User created with email: ${resp.email}`);
        })
        .catch((error: string) => {
          setInvalidEmail(error);
          message.error(error);
          dispatch(getAssociatePeople());
        });
    }
    setInvalidEmail("");
    setShowAddUserModal(false);
  };

  const handleActive = (checked: boolean, id: string) => {
    api
      .patch(`user/update-status/${id}`, { active: checked })
      .then((response: any) => {
        dispatch(getAssociatePeople());
        setUsers(
          users.map((item: any) => {
            if (item._id === id) {
              return response;
            }
            return item;
          }),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleEdit = (row: any) => {
    setInvalidEmail("");
    setEdit(row);
    setShowAddUserModal(true);
  };

  const handleBidReview = async (e: any, id: any) => {
    try {
      const sendBidReview = e.target.checked;
      await api.patch(`user/update-bid-review/${id}`, { sendBidReview });
      // Update the local state with the new `sendBidReview` value
      setUsers((prevUsers: any) =>
        prevUsers.map((user: any) =>
          user._id === id ? { ...user, sendBidReview } : user,
        ),
      );

      // Update associate people data
      dispatch(getAssociatePeople());
    } catch (error) {
      console.error("Error updating bid review status:", error);
      message.error("Failed to update bid review status");
    }
  };

  const updatedColumns = [
    ...columns,
    {
      title: 'Company',
      dataIndex: 'companyInfo',
      render: (companyInfo: any) => {
        console.log(companyInfo)
        const currentTenantCompanyInfo = companyInfo.find((item: any) => item?.tenant === tenantId);
        console.log(currentTenantCompanyInfo);
        return (
          <p>{currentTenantCompanyInfo?.companyName}</p>
        )
      }
    },
    {
      title: "Send Bid Review",
      dataIndex: "sendBidReview",
      render: (sendBidReview: any, record: any) =>
        record.roles?.includes("admin") ? (
          <Checkbox
            checked={sendBidReview}
            onChange={(e) => handleBidReview(e, record._id)}
          />
        ) : (
          <></>
        ),
    },
    {
      title: "Active",
      render: (data: any) => (
        <Switch
          disabled={data._id === user?._id}
          onChange={(checked) => handleActive(checked, data._id)}
          checked={data.active}
        />
      ),
    },
    {
      title: "Edit",
      render: (data: any) => (
        <EditOutlined
          onClick={() => handleEdit(data)}
          style={{ color: "#FDB913", cursor: "pointer", fontSize: "20px" }}
        />
      ),
    },
  ];

  return (
    <div className="pay-processing-root">
      <CreateAccountC
        row={edit}
        showAddUserModal={showAddUserModal}
        toggleShowAddUserModal={toggleShowAddUserModal}
        handleAddUser={onFinish}
        invalidEmail={invalidEmail}
      />
      <Row className="pp-default-header" align="middle" justify="space-between">
        <Col>
          <h1>Users</h1>
        </Col>
        <Col>
          <Button
            className="pp-add-associates"
            type="primary"
            onClick={handleAddUser}
          >
            Add User
          </Button>
        </Col>
      </Row>
      {loading ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <>
          <hr style={{ border: "1px solid #E8E8E8" }} />
          <div className="pp-default-table">
            {users?.length > 0 && (
              <Table
                scroll={{ x: "900px" }}
                columns={updatedColumns}
                dataSource={users}
                rowKey="_id"
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Users;
